import {
	API_ASSIGN_ROUND,
	API_END_ROUND,
	API_GET_BY_DATE_ROUND,
	API_GET_CURRENT_ROUND,
	API_GET_ROUND,
	API_PATCH_APPOINTMENT,
	API_UNASSIGN_ROUND,
	API_GET_SYNC_ROUNDS
} from 'actions/round';

export function getCurrentRound() {
	return {
		type: API_GET_CURRENT_ROUND,
		payload: {
			request: {
				url: `/rounds/current`
			}
		}
	};
}

export function getRoundsByDate(date) {
	return {
		type: API_GET_BY_DATE_ROUND,
		payload: {
			request: {
				url: `/rounds/${date}`
			}
		}
	};
}

export function getRound(id) {
	return {
		type: API_GET_ROUND,
		payload: {
			request: {
				url: `/rounds/${id}`
			}
		}
	};
}

export function assignRound(id) {
	return {
		type: API_ASSIGN_ROUND,
		payload: {
			request: {
				url: `/rounds/${id}/assign`,
				method: 'POST'
			}
		}
	};
}

export function endRound(id) {
	return {
		type: API_END_ROUND,
		payload: {
			request: {
				url: `/rounds/${id}/end`,
				method: 'POST'
			}
		}
	};
}

export function unassignRound(id) {
	return {
		type: API_UNASSIGN_ROUND,
		payload: {
			request: {
				url: `/rounds/${id}/unassign`,
				method: 'POST'
			}
		}
	};
}

export function patchAppointment(appointment) {
	return {
		type: API_PATCH_APPOINTMENT,
		payload: {
			request: {
				url: `/appointments/${appointment.id}`,
				method: 'PATCH',
				data: appointment
			}
		}
	};
}

export function getSyncRounds(nurseId, date) {
	return {
		type: API_GET_SYNC_ROUNDS,
		payload: {
			request: {
				url: `/rounds/sync/${date}/${nurseId}`,
				method: 'GET'
			}
		}
	};
}
